import { isEmpty, get, extend } from 'lodash-es';
import axios from 'axios';
import debug from 'debug';
import type { Method, AxiosRequestConfig } from 'axios';
import { enhanceResponseWithEtag, formatPayload } from './helpers';
import { RequestArgs } from './types';

const log = debug('itp:core:connections:core');

const REQUEST_TIMEOUT_MS = 20000; // 20 sec

export function request(url: string, args?: RequestArgs) {
  log('request to %o [args: %o]', url, args);

  let content = args ? args.content : undefined,
    method = args && args.method ? args.method : 'get',
    headers = args ? headersFor(method, args) : {},
    data = content;

  if (!isEmpty(headers)) {
    log('headers: %o', headers);
  }

  if (data && headers && headers['Content-Type']) {
    data = formatPayload(data, headers['Content-Type']);
    log('data: %o', data);
  }

  const extras: Dictionary<any> = {};
  if (args && args.responseType) {
    extras.responseType = args.responseType;
  }

  return ajax({
    method: method as Method,
    url,
    data,
    headers,
    timeout: REQUEST_TIMEOUT_MS,
    ...extras,
  });
}

function ajax(config: AxiosRequestConfig) {
  return axios(config).then((response) => {
    response = enhanceResponseWithEtag(response);
    // log('response data: %o', response.data);
    return response;
  });
}

function headersFor(method: string, args: RequestArgs) {
  const result = extend({}, args.headers);

  const content = args.content,
    params = args.parameters;

  if (content && ['patch', 'delete'].indexOf(method) > -1) {
    const etag =
      get(content, '$etag') ||
      get(content, 'etag') ||
      (params && (params['$etag'] || params['etag']));

    if (etag) {
      result['If-Match'] = etag;
    }
  }

  if (args.contentType) {
    result['Content-Type'] = args.contentType;
  }

  if (args.language) {
    result['Accept-Language'] = `${args.language},en;q=0.5`;
  }

  return result;
}
